<script>
import Layout from '@layout/main'

export default {
  page() {
    return {
      title: `網站地圖`,
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      menuList: [
        {
          title: '最新消息',
          alias: 'news',
          children: [
            {
              title: '促銷訊息',
              to: {
                name: 'news-category',
                params: {
                  categoryAlias: 'promotion',
                },
              },
            },
            {
              title: '品牌新訊',
              to: {
                name: 'news-category',
                params: {
                  categoryAlias: 'bulletin',
                },
              },
            },
          ],
        },
        {
          title: '產品服務',
          alias: 'news',
          children: [
            {
              title: '代理品牌',
              alias: 'brand-list',
              to: {
                name: 'brand-list',
              },
            },
            {
              title: '產品系列',
              alias: 'product-list',
              to: {
                name: 'product-list',
              },
            },
            {
              title: '共同供應契約採購',
              alias: 'bot-list',
              to: {
                name: 'bot-list',
              },
            },
            {
              title: '雲端服務網',
              alias: 'cloud',
              type: 'link',
              path: 'https://csp.zerone.com.tw/',
            },
            {
              title: 'ZOiPS數位監控',
              alias: 'ZOiPS',
              type: 'link',
              path: 'http://www.zoips.com.tw/',
            },
              {
                text: 'AOD',
                alias: 'AOD',
                type: 'link',
                path: 'https://www.aod.com.tw/zh-tw/',
              },
          ],
        },
        {
          title: '課程活動',
          alias: 'event-list',
          to: {
            name: 'event-list',
          },
        },
        // {
        //   title: '解決方案',
        //   alias: 'solution-list',
        //   to: {
        //     name: 'solution-list'
        //   },
        // },
        {
          title: '影片專區',
          alias: 'video-list',
          to: {
            name: 'video-list',
          },
        },
        {
          title: '關於零壹',
          alias: 'about',
          children: [
            {
              title: '公司簡介',
              to: {
                name: 'about-zerone',
              },
            },
            {
              title: '經營團隊',
              to: {
                name: 'about-organization',
              },
            },
            {
              title: '大事紀',
              to: {
                name: 'about-history',
              },
            },
          ],
        },
        {
          title: '投資人專區',
          children: [
            {
              title: '財務資訊',
              to: {
                name: 'investor-finance',
              },
            },
            {
              title: '公司治理',
              to: {
                name: 'investor-companypolicy',
              },
            },
            {
              title: '利害關係人專區',
              to: {
                name: 'investor-int',
              },
            },
            {
              title: '股東專欄',
              to: {
                name: 'investor-shareholders',
              },
            },
          ],
        },
        {
          title: '聯絡我們',
          alias: 'contact',
          children: [
            {
              title: '業務洽詢',
              to: {
                name: 'inquiry',
              },
            },
            {
              title: '聯絡銷售人員',
              to: {
                name: 'contactSales',
              },
            },
            {
              title: '營業據點',
              to: {
                name: 'location',
              },
            },
            {
              title: '維修服務',
              to: {
                name: 'repair',
              },
            },
            {
              title: '申請成為經銷商',
              to: {
                name: 'tobeDealer',
              },
            },
            {
              title: '其他詢問',
              to: {
                name: 'inquiryOther',
              },
            },
          ],
        },
        {
          title: '網站資訊',
          alias: 'info',
          children: [
            // {
            //   title: '訂閱電子報',
            //   to:{
            //     name: 'subscription',
            //   }
            // },
            // {
            //   title: '檔案下載',
            //   to: {
            //     name: 'file',
            //   }
            // },
            // {
            //   title: '常見問答',
            //   to:{
            //     name: 'faq',
            //   }
            // },
            {
              title: '隱私權與服務條款',
              to: {
                name: 'privacy',
              },
            },
          ],
        },
      ],
    }
  },
}
</script>
<template>
  <Layout>
    <div :class="$style.sitemap">
      <BaseBanner title="網站地圖" :image="require('@assets/images/service/index_banner.png')" class="isHasNoFilter" custom-class="isStyleWhite" />
      <section class="section container sitemap">
        <div v-for="(menu, $index) in menuList" :key="$index" class="sitemap__menuList">
          <template v-if="menu.children">
            <div class="sitemap__menulevel1">
              <span :class="[menu.alias]">{{ menu.title }}</span>
            </div>
            <ul class="d-flex list-unstyled m-0">
              <li v-for="(menuChild, $index2) in menu.children" :key="$index2" class="sitemap__menulevel2">
                <template v-if="menuChild.children">
                  {{ menuChild.title }}
                  <ul class="list-unstyled m-0">
                    <li v-for="(child, $index3) in menuChild.children" :key="$index3" class="sitemap__menulevel3">
                      <router-link :to="child.to" class="sitemap__isLink">
                        {{ child.title }}
                      </router-link>
                    </li>
                  </ul>
                </template>
                <template v-else>
                  <template v-if="menuChild.type === 'link'">
                    <a :href="menuChild.path" target="_blank" class="sitemap__isLink">
                      {{ menuChild.title }}
                    </a>
                  </template>
                  <template v-else>
                    <router-link :to="menuChild.to" class="sitemap__isLink">
                      {{ menuChild.title }}
                    </router-link>
                  </template>
                </template>
              </li>
            </ul>
          </template>
          <template v-else>
            <template v-if="menu.type === 'link'">
              <a :href="menuChild.path" target="_blank" class="sitemap__isLink sitemap__menulevel1">
                {{ menuChild.title }}
              </a>
            </template>
            <template v-else>
              <router-link :to="menu.to" class="sitemap__isLink sitemap__menulevel1">
                <span :class="[menu.alias]">{{ menu.title }}</span>
              </router-link>
            </template>
          </template>
        </div>
      </section>
    </div>
  </Layout>
</template>
<style lang="scss" module>
.sitemap {
  :global {
    .sitemap {
      margin-top: -130px;

      @include max-md {
        margin-top: -2rem;
      }

      &__menulevel1 {
        display: block;
        padding: 20px 0;
        font-size: 1.875rem;
        font-weight: 500;
        border-bottom: 1px solid $color-gray-3;

        @include max-md {
          font-size: 1.5rem;
        }
      }

      &__menulevel2 {
        margin-top: 40px;
        margin-right: 3rem;
        font-size: 1.5rem;
        font-weight: 500;

        @include max-md {
          margin-right: 0;
          font-size: 1rem;
        }

        .sitemap__isLink {
          &::before {
            margin-right: 1px;
            font-size: 1.25rem;
            font-weight: 400;
            @include max-md {
              font-size: 1rem;
            }
          }
        }
      }

      &__menulevel3 {
        margin-top: 40px;
        font-size: 1.25rem;
        font-weight: 400;
        @include max-md {
          font-size: 1rem;
        }
      }

      &__menuList {
        margin-top: 130px;

        @include max-md {
          margin-top: 2rem;
        }

        @include max-md {
          > ul {
            flex-direction: column;
            font-size: 1rem;

            li {
              padding-left: 1rem;
            }
          }
        }
      }

      &__isLink {
        color: $color-gray-7;
        text-decoration: none;
        transition: 0.3s;

        &:hover {
          color: $color-primary-hover;
        }

        &::before {
          margin-right: 16px;
          font-family: 'Font Awesome 5 Pro';
          font-size: 1.5rem;
          content: '\f054';
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>
